import React from 'react';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';

interface EditRubricCategoryCriteriaPreviewProps {
  criteria: string;
  weight: number;
}

export const EditRubricCategoryCriteriaPreview: React.FC<
  EditRubricCategoryCriteriaPreviewProps
> = ({ criteria, weight }) => {
  return (
    <Spacing
      direction="horizontal"
      size="gap-20"
      className="rounded-lg bg-indigo-100 px-5 py-4 justify-between flex items-center"
    >
      <S2Typography
        variant="body-6"
        textColorVariant="indigo-1000"
        translatedContent={criteria}
      />
      <div className="flex items-center justify-center w-[37px] h-[37px] bg-indigo-900 rounded-lg flex-none">
        <S2Typography
          variant="body-7-bold"
          textColorVariant="white"
          translatedContent={String(weight)}
        />
      </div>
    </Spacing>
  );
};
